import {ACC, DESC} from "../constants/sortConst";
import {SORT_SELECT} from "../constants/elementConst";

export default function(){
    return `
        <div class="employee_register__sort">
            <label class="employee_register__sort__label">
                <span class="employee_register__text--bold">Sorter etter<span>
                <select class="employee_register__sort__select employee_register--py-10 employee_register--px-15" data-js="${SORT_SELECT}">
                    <option value="">Relevans</option>
                    <option value="${ACC}">Etternavn A-Å</option>
                    <option value="${DESC}">Etternavn Å-A</option>
                </select>
            </label>
        </div>
    `;
}